module.exports = __webpack_public_path__ + "static/img/b1.f79636ee.png";